module.exports = __webpack_public_path__ + "img/akhmetov.87def821.png";